import React, { useContext } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ViewContext } from "./contexts/ViewContext";
import StoreIcon from "@mui/icons-material/Store";
import PanToolIcon from "@mui/icons-material/PanTool";

export default function PoiThanks() {
    const { view, dispatch } = useContext(ViewContext);

    return (
        <div>
            <p>
                Gratulálunk! Hozzájárultál, hogy a világ jobb hely legyen a
                kerekesszékkel közlekedők részére.
                <br />
                Ha van kedved, folytasd!
            </p>
            <List>
                <ListItem
                    button
                    selected={view.page === "poi-select"}
                    key="poi"
                    to={"/hu/poi"}
                    onClick={() =>
                        dispatch({
                            type: "GOTO PAGE",
                            pageType: "poi",
                            pageNo: 1,
                        })
                    }
                >
                    <ListItemIcon>
                        <StoreIcon />
                    </ListItemIcon>
                    <ListItemText primary="Hely értékelése" />
                </ListItem>
                <ListItem
                    button
                    selected={view.page === "obstacle"}
                    key="obstacle"
                    to={"/hu/obstacle"}
                    onClick={() =>
                        dispatch({
                            type: "GOTO PAGE",
                            pageType: "obstacle",
                            pageNo: 1,
                        })
                    }
                >
                    <ListItemIcon>
                        <PanToolIcon />
                    </ListItemIcon>
                    <ListItemText primary="Akadály jelentése" />
                </ListItem>
            </List>
        </div>
    );
}
